// import React, { useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import axios from "axios";
// import { baseURL } from "../Data/api";
// import { TreeTable } from "primereact/treetable";
// import { Column } from "primereact/column";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import loaderAnimation from '../assets/images/loader (2).json'; 
// import Lottie from 'lottie-react';
// import { useNavigate } from "react-router-dom";
// import Cookies from 'js-cookie'
// import './styles.css';
// import * as XLSX from "xlsx"


// const MisReport = () => {
//     const [drawWinner, setDrawWinner] = useState([]);
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [submitted, setSubmitted] = useState(false);
//     const [rows, setRows] = useState(25);
//     const [serviceName, setServiceName] = useState('');
//     const [currency, setCurrency] = useState('');

    


//     console.log("Start Date:", startDate);
//     console.log("End Date:", endDate);

//     const navigate=useNavigate()
//           const username = Cookies.get('username')
        
//           const checkuser = () => {
//             if (!username || username == null || username == undefined) {
//               navigate('/login')
//             }
//           }
    
//           useEffect(()=>{
//             checkuser()
//           },[])
    
//     const fetchData = async () => {
//         if (!startDate || !endDate || !serviceName) {
//             alert("Please select all fields");
//             return;
//         }

//         setLoading(true);
//         setSubmitted(true);
//         try {
//             const response = await axios.get(`${baseURL}/api/v1/misReport`, {
//                 params: {
//                     serviceName :serviceName,
//                     currency:currency,
//                     startDate: startDate,
//                     endDate: endDate,
//                 },
//             });
            
//             console.log('paid API Response Data:', response.data);
//             console.log('paid API Response Status:', response.status);

//             // setDrawWinner(response.data);
//             setDrawWinner(
//   response.data.map((item) => ({
//     ...item,
//     total_base: item.misReport?.[0]?.total_base,
//     active_base: item.misReport?.[0]?.active_base,
//     renewals_failed: item.misReport?.[0]?.renewals_failed,
//   }))
// );
//             console.log('Updated drawWinner state:', response.data);
//         } catch (error) {
//             console.error("Error fetching data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         fetchData();
//     };

//     const formatDate = (date, isEndDate = false) => {
//         if (!date) return '';
//         const time = isEndDate ? '23:59:59' : '00:00:00';
//         const formatted = dayjs(date).format('YYYY-MM-DD') + ` ${time}`;
//         console.log('Formatted Date:', formatted);
//         return formatted;
//     };

//     const downloadExcel = () => {
//         const filteredData = drawWinner.map(({ 
//             misDate,
//             totalSubscription,
//             paidSubscription,
//             subscriptionRevenue,
//             renewals,
//             renewalsRevenue,
//             unsubscription, total_base,
//         active_base,
//          renewals_failed }) => ({
//                 misDate,
//                 totalSubscription,
//                 paidSubscription,
//                 subscriptionRevenue,
//                 renewals,
//                 renewalsRevenue,
//                 unsubscription,
//                  total_base,
//         active_base,
//         renewals_failed

//         }));

//         const worksheet = XLSX.utils.json_to_sheet(filteredData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "MisReport");
//         XLSX.writeFile(workbook, "MisReport.xlsx");
//     };

//     return (
//         <Layout>
//             <div className="">
//                 <div className="flex justify-between">
//                     <span className="font-semibold text-lg text-black">MisReport</span>
//                 </div>
//             </div>

//             <div className="flex justify-center items-center mt-3 text-black">
//                 <form onSubmit={handleSubmit} className="flex flex-col lg:flex-row gap-6 items-center bg-gray-100 p-6 rounded-lg shadow-lg w-full max-w-5xl">
//                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                         <div className="flex flex-col lg:flex-row  gap-4 w-full">

//                         <div className="w-full">
//                                 <label>Service</label>
//                                 <select
//                                     value={serviceName}
//                                     onChange={(e) => setServiceName(e.target.value)}
//                                     className="w-full p-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
//                                 <option>Select Service</option>

//                                     <option value="MyKidzHub">MyKidzHub</option>
//                                     <option value="YoGamezPro">YoGamezPro</option>
//                                     <option value="YoNumbers">YoNumbers</option>
//                                           <option value="YoGamezXR">YoGamezXR</option>

//                                 </select>
//                             </div>

//                             <div className="w-full">
//                                 <label>Currency</label>
//                                 <select
//                                     value={currency}
//                                     onChange={(e) => setCurrency(e.target.value)}
//                                     className="w-full p-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
//                                 <option>Select Currency</option>

//                                     <option value="USD">USD</option>
//                                     <option value="ZWG">ZWG</option>
                                    
//                                 </select>
//                             </div>
//                             <div className="w-full">
//                                 <label>Start Date</label>
//                                 <DatePicker
//                                     value={startDate ? dayjs(startDate) : null}
//                                     onChange={(newValue) => {
//                                         const formattedDate = formatDate(newValue);
//                                         console.log('Selected Start Date:', formattedDate);
//                                         setStartDate(formattedDate);
//                                     }}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                             <div className="w-full">
//                                 <label>End Date</label>
//                                 <DatePicker
//                                     value={endDate ? dayjs(endDate) : null}
//                                     onChange={(newValue) => {
//                                         const formattedDate = formatDate(newValue, true);
//                                         console.log('Selected End Date:', formattedDate);
//                                         setEndDate(formattedDate);
//                                     }}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                         </div>
//                     </LocalizationProvider>

//                     <button type="submit" className="bg-blue-500 lg:mt-6 text-white p-2 rounded hover:bg-blue-400">
//                         Submit
//                     </button>
//                 </form>
//             </div>

//             {loading && <div className="flex justify-center items-center w-full mt-10 lg:mt-4 ">
//                 <Lottie animationData={loaderAnimation} style={{ width: 200, height: 200 }} />
//             </div>}

//             {!loading && submitted && drawWinner.length === 0 && <p className="text-center text-red-500 mt-4">No Data Found</p>}

//             {!loading && drawWinner.length > 0 && (
//                 <div className="overflow-x-auto mt-10 ">
//                     <div className="flex justify-end mb-4">
                     

//                      <button onClick={downloadExcel} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-400">
//                          Download
//                      </button>
//                  </div>
//                     <TreeTable  className="w-[400px] sm:w-[660px] md:w-[790px] lg:w-[980px]"

//                         value={drawWinner.map((item, index) => ({
//                             key: index.toString(),
//                             data: { ...item, serialNumber: index + 1 }
//                         }))}
//                         tableStyle={{ minWidth: "50rem" }}
//                         paginator
//                         rowsPerPageOptions={[25, 50,75,100]}
//                         rows={rows}
//                     >
//                     <Column field="serialNumber" header="S.No" style={{ width: "60px" }}
//                             body={(rowData) => rowData.data.serialNumber}></Column>
//                      <Column field="misDate" header="Date"style={{ width: "180px" }}></Column>
//                      <Column field="totalSubscription" header="TotalSubscription"  style={{ width: "180px" }}></Column>
//                     <Column field="paidSubscription" header="PaidSubscription" style={{ width: "180px" }}></Column>
                 
//                     <Column field="subscriptionRevenue" header="SubscriptionRevenue"  
//                          body={(rowData) => {
//                             const revenue = parseFloat(rowData.data.subscriptionRevenue);
//                             console.log('Raw dailyUSDRevenue:', rowData.data.subscriptionRevenue); // Debugging

//                             return !isNaN(revenue) ? revenue.toFixed(2) : revenue;
//                         }}
//                         style={{ width: "180px" }}>
//                  </Column>
//                  <Column field="renewals" header="Renewals" style={{ width: "180px" }}></Column>
//                  <Column field="renewalsRevenue" header="RenewalsRevenue" 
//                          body={(rowData) => {
//                             const revenue = parseFloat(rowData.data.renewalsRevenue);
//                             // console.log('Raw dailyUSDRevenue:', rowData.data.weeklyUSDRevenue); // Debugging

//                             return !isNaN(revenue) ? revenue.toFixed(2) : revenue;
//                         }}
//                         style={{ width: "180px" }}>
//                  </Column>

                  
//                     <Column field="unsubscription" header="Unsubscription" style={{ width: "180px" }}></Column>
//                     {/* <Column field="Total Base" header="TotalBase" style={{ width: "180px" }}></Column>
//                     <Column field="Active Base" header="ActiveBase" style={{ width: "180px" }}></Column>
//                     <Column field="Failed Renewals Count" header="FailedRenCount" style={{ width: "180px" }}></Column> */}


//                    <Column field="total_base" header="TotalBase" style={{ width: "180px" }}></Column>
// <Column field="active_base" header="ActiveBase" style={{ width: "180px" }}></Column>
// <Column field="renewals_failed" header="FailedRenCount" style={{ width: "180px" }}></Column>
                    

//                     </TreeTable>
//                 </div>
//             )}
//         </Layout>
//     );
// };

// export default MisReport;



import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import axios from "axios";
import { baseURL } from "../Data/api";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import loaderAnimation from '../assets/images/loader (2).json'; 
import Lottie from 'lottie-react';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'
import './styles.css';
import * as XLSX from "xlsx"

const MisReport = () => {

const [drawWinner, setDrawWinner] = useState([]);
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
const [loading, setLoading] = useState(false);
const [submitted, setSubmitted] = useState(false);
const [rows, setRows] = useState(25);
const [serviceName, setServiceName] = useState('');
const [currency, setCurrency] = useState('');

const navigate = useNavigate()
const username = Cookies.get('username')

const checkuser = () => {
if (!username) {
navigate('/login')
}
}

useEffect(()=>{
checkuser()
},[])

const fetchData = async () => {

if (!startDate || !endDate || !serviceName) {
alert("Please select all fields");
return;
}

setLoading(true);
setSubmitted(true);

try {

const response = await axios.get(`${baseURL}/api/v1/misReport`, {
params: {
serviceName: serviceName,
currency: currency,
startDate: startDate,
endDate: endDate,
},
});

setDrawWinner(
response.data.map((item) => ({
...item,
total_base: item.misReport?.[0]?.total_base,
active_base: item.misReport?.[0]?.active_base,
renewals_failed: item.misReport?.[0]?.renewals_failed,
}))
);

} catch (error) {
console.error("Error fetching data:", error);
}
finally {
setLoading(false);
}

};

const handleSubmit = (e) => {
e.preventDefault();
fetchData();
};

const formatDate = (date, isEndDate = false) => {

if (!date) return '';

const time = isEndDate ? '23:59:59' : '00:00:00';
return dayjs(date).format('YYYY-MM-DD') + ` ${time}`;

};

const downloadExcel = () => {

const filteredData = drawWinner.map(({ 
misDate,
totalSubscription,
paidSubscription,
subscriptionRevenue,
renewals,
renewalsRevenue,
unsubscription,
total_base,
active_base,
renewals_failed
}) => ({

misDate,
totalSubscription,
paidSubscription,
subscriptionRevenue,
renewals,
renewalsRevenue,
unsubscription,
total_base,
active_base,
renewals_failed

}));

const worksheet = XLSX.utils.json_to_sheet(filteredData);
const workbook = XLSX.utils.book_new();

XLSX.utils.book_append_sheet(workbook, worksheet, "MisReport");
XLSX.writeFile(workbook, "MisReport.xlsx");

};

return (

<Layout>

<div className="flex justify-between">
<span className="font-semibold text-lg text-black">MisReport</span>
</div>

{/* FILTER FORM */}

<div className="flex justify-center items-center mt-3 text-black">

<form
onSubmit={handleSubmit}
className="flex flex-col lg:flex-row gap-6 items-center bg-gray-100 p-6 rounded-lg shadow-lg w-full max-w-5xl"
>

<LocalizationProvider dateAdapter={AdapterDayjs}>

<div className="flex flex-col lg:flex-row gap-4 w-full">

<div className="w-full">
<label>Service</label>
<select
value={serviceName}
onChange={(e) => setServiceName(e.target.value)}
className="w-full p-4 border-zinc-400 rounded bg-gray-50 border"
>
<option>Select Service</option>
<option value="MyKidzHub">MyKidzHub</option>
<option value="YoGamezPro">YoGamezPro</option>
<option value="YoNumbers">YoNumbers</option>
<option value="YoGamezXR">YoGamezXR</option>
</select>
</div>

<div className="w-full">
<label>Currency</label>
<select
value={currency}
onChange={(e) => setCurrency(e.target.value)}
className="w-full p-4 border-zinc-400 rounded bg-gray-50 border"
>
<option>Select Currency</option>
<option value="USD">USD</option>
<option value="ZWG">ZWG</option>
</select>
</div>

<div className="w-full">
<label>Start Date</label>
<DatePicker
value={startDate ? dayjs(startDate) : null}
onChange={(newValue)=>setStartDate(formatDate(newValue))}
format="YYYY-MM-DD"
className="w-full"
/>
</div>

<div className="w-full">
<label>End Date</label>
<DatePicker
value={endDate ? dayjs(endDate) : null}
onChange={(newValue)=>setEndDate(formatDate(newValue,true))}
format="YYYY-MM-DD"
className="w-full"
/>
</div>

</div>

</LocalizationProvider>

<button
type="submit"
className="bg-blue-500 lg:mt-6 text-white px-4 py-2 rounded hover:bg-blue-400"
>
Submit
</button>

</form>

</div>

{/* LOADER */}

{loading && (
<div className="flex justify-center mt-10">
<Lottie animationData={loaderAnimation} style={{ width:200 }} />
</div>
)}

{/* NO DATA */}

{!loading && submitted && drawWinner.length === 0 && (
<p className="text-center text-red-500 mt-4">No Data Found</p>
)}

{/* TABLE */}

{!loading && drawWinner.length > 0 && (

<div className="flex justify-center mt-10">

<div className="overflow-x-auto w-full max-w-6xl">

<div className="flex justify-center lg:justify-end mb-4">

<button
onClick={downloadExcel}
className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-400"
>
Download
</button>

</div>

<TreeTable
className="w-full"
value={drawWinner.map((item,index)=>({
key:index.toString(),
data:{...item,serialNumber:index+1}
}))}
tableStyle={{ minWidth:"50rem" }}
paginator
rows={rows}
rowsPerPageOptions={[25,50,75,100]}
stripedRows
showGridlines
>

<Column field="serialNumber" header="S.No" style={{width:"60px"}} body={(rowData)=>rowData.data.serialNumber}/>

<Column field="misDate" header="Date" style={{width:"180px"}}/>

<Column field="totalSubscription" header="TotalSubscription" style={{width:"180px"}}/>

<Column field="paidSubscription" header="PaidSubscription" style={{width:"180px"}}/>

<Column
field="subscriptionRevenue"
header="SubscriptionRevenue"
body={(rowData)=>{
const revenue=parseFloat(rowData.data.subscriptionRevenue);
return !isNaN(revenue)?revenue.toFixed(2):revenue;
}}
style={{width:"180px"}}
/>

<Column field="renewals" header="Renewals" style={{width:"180px"}}/>

<Column
field="renewalsRevenue"
header="RenewalsRevenue"
body={(rowData)=>{
const revenue=parseFloat(rowData.data.renewalsRevenue);
return !isNaN(revenue)?revenue.toFixed(2):revenue;
}}
style={{width:"180px"}}
/>

<Column field="unsubscription" header="Unsubscription" style={{width:"180px"}}/>

<Column field="total_base" header="TotalBase" style={{width:"180px"}}/>

<Column field="active_base" header="ActiveBase" style={{width:"180px"}}/>

<Column field="renewals_failed" header="FailedRenCount" style={{width:"180px"}}/>

</TreeTable>

</div>
</div>

)}

</Layout>

);
};

export default MisReport
